export default {
    tabs: {
        received: 'Referrals received',
        made: 'Referrals made',
    },
    buttons: {
        referral_overview: 'Generate referral overview',
    },
    barchart: {
        locations: 'Locations',
        providers: 'Providers',
        physicians: 'Providers',
    },
    piechart: {
        insurance: 'Insurance',
        diagnosis: 'Diagnosis',
        age: 'Age',
        referrer: 'Referrer',
    },
    error: 'An error occurred, please refresh the page',
    no_received_data: 'There are no received referrals for the selected time period.',
    no_made_data: 'There are no made referrals for the selected time period.',
}
